import React from "react";
import emptyStateImage from "../../assets/images/Empty-State-Cat.png";
import "../../styles/EmptyState.css";
import Button from "./Button";
import { useNavigate } from "../../imports";

const EmptyState: React.FC = () => {
  const navigate = useNavigate();

  const handleCreateClick = () => {
    navigate("/workspace?tab=shortener");
  };

  return (
    <div className="empty-state-container">
      <div className="empty-state-image">
        <img src={emptyStateImage} alt="Meow!" />
      </div>
      <div className="empty-state-content">
        <h2>
          No links detected. Time to give the kitty something to celebrate...
        </h2>
        <Button
          variant="primary"
          onClick={handleCreateClick}
          className="create-first-link-btn"
        >
          Create Your First Link!
        </Button>
      </div>
    </div>
  );
};

export default EmptyState;
